import { css } from "styled-components";

import { Palette } from "../../core/styles/theme";

export const colorBadgeStyle = css`
    &.aevi-status-badge {
        display: inline-block;

        sup {
            color: ${Palette.White};
            padding: 0 14px;
            min-width: 20px;
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            white-space: nowrap;
            text-align: center;
            border-radius: 10px;
            box-shadow: 0 0 0 1px ${Palette.White};
            transition: background 0.2s;
            position: relative;
            top: auto;
            display: block;
            transform-origin: 50% 50%;
            transform: none;
            font-family: RobotoLight;
        }

        &.aevi-active {
            sup {
                background-color: ${Palette.HeroGreen};
            }
        }

        &.aevi-inactive {
            sup {
                background-color: ${Palette.LightPink};
            }
        }

        &.aevi-created {
            sup {
                background-color: ${Palette.LightPink};
            }
        }

        &.aevi-generated {
            sup {
                background-color: ${Palette.Warning};
            }
        }

        &.aevi-updated {
            sup {
                background-color: ${Palette.HeroGreen};
            }
        }

        &.aevi-stopped {
            sup {
                background-color: ${Palette.DarkGreen};
            }
        }

        &.aevi-failed {
            sup {
                background-color: ${Palette.AeviRed};
            }
        }

        &.aevi-pale-pink {
            sup {
                background-color: ${Palette.PalePink};
                color: ${Palette.AeviBlack};
            }
        }
    }
`;
